import React, { useState } from 'react';
import { Menu, X, Check, TrendingUp, Zap, Shield, Brain, Users, Building2, Heart, GraduationCap, LineChart, Clock, Lock, Award, ChevronDown } from 'lucide-react';

export default function ExitoLandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-[88px]">
            <div className="flex items-center">
              <div className="flex items-center">
                {/* Esta é a imagem do logo */}
                  <img 
                    src="/exito-logo.png" 
                    alt="Logo Êxito Gestão Tecnológica" 
                    className="w-[92] h-[92px]"
                  />
                {/* <div className="ml-3">
                  <div className="text-2xl font-bold text-blue-900">ÊXITO</div>
                  <div className="text-xs text-blue-700">GESTÃO TECNOLÓGICA</div>
                </div> */}
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('solucao')} className="text-gray-700 hover:text-blue-600 transition">Solução</button>
              <button onClick={() => scrollToSection('impacto')} className="text-gray-700 hover:text-blue-600 transition">Impacto</button>
              <button onClick={() => scrollToSection('processo')} className="text-gray-700 hover:text-blue-600 transition">Processo</button>
              <button onClick={() => scrollToSection('contato')} className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2 rounded-full hover:shadow-lg transition">
                Fale Conosco
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-gray-700">
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 pt-2 pb-4 space-y-2">
              <button onClick={() => scrollToSection('solucao')} className="block w-full text-left py-2 text-gray-700">Solução</button>
              <button onClick={() => scrollToSection('impacto')} className="block w-full text-left py-2 text-gray-700">Impacto</button>
              <button onClick={() => scrollToSection('processo')} className="block w-full text-left py-2 text-gray-700">Processo</button>
              <button onClick={() => scrollToSection('contato')} className="block w-full bg-orange-500 text-white py-2 px-4 rounded-full mt-2">
                Fale Conosco
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-32 md:pb-40 lg:pb-48 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-visible">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-400 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-6">
                +80 Cidades Confiam em Nós
              </div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                Compras Públicas com <span className="text-orange-400">Êxito</span>
              </h1>
              <p className="text-xl text-blue-100 mb-8">
                Nosso trabalho transforma municípios em referências.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={() => scrollToSection('contato')} className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-xl hover:shadow-2xl transition transform hover:scale-105">
                  Solicite uma Demonstração
                </button>
                <button onClick={() => scrollToSection('solucao')} className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-blue-900 transition">
                  Conheça a Solução
                </button>
              </div>
            </div>
            
            <div className="relative mt-8 md:mt-0">
              <img 
                src="/cidades.png" 
                alt="Mapa com estatísticas - 30% Economia, 60% Mais Licitações, 100% Mais Velocidade, 98% Retenção" 
                className="w-full h-auto relative z-10 transform scale-110 md:scale-115 lg:scale-125 translate-y-6 md:translate-y-8 lg:translate-y-10"
                style={{ 
                  filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3))',
                  imageRendering: '-webkit-optimize-contrast',
                  imageRendering: 'crisp-edges'
                }}
              />
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full block" preserveAspectRatio="none" style={{ height: '120px', display: 'block' }}>
            <path d="M0 0L60 10C120 20 240 40 360 50C480 60 600 60 720 55C840 50 960 40 1080 35C1200 30 1320 30 1380 30L1440 30V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="#FFFFFF"/>
          </svg>
        </div>
      </section>

      {/* Desafios Section */}
      <section className="pt-28 md:pt-32 lg:pt-36 pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Desafios Enfrentados Diariamente pela Administração Pública
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-5 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-700 rounded-full flex items-center justify-center mb-4 mx-auto">
                <Users className="text-white" size={32} />
              </div>
              <h3 className="text-center font-semibold text-gray-800">Falta de Planejamento</h3>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mb-4 mx-auto">
                <AlertTriangle className="text-white" size={32} />
              </div>
              <h3 className="text-center font-semibold text-gray-800">Cotações Mal Elaboradas</h3>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mb-4 mx-auto">
                <Clock className="text-white" size={32} />
              </div>
              <h3 className="text-center font-semibold text-gray-800">Processos Lentos</h3>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-full flex items-center justify-center mb-4 mx-auto">
                <LineChart className="text-white" size={32} />
              </div>
              <h3 className="text-center font-semibold text-gray-800">Controle dos Saldos de Atas</h3>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center mb-4 mx-auto">
                <TrendingUp className="text-white" size={32} />
              </div>
              <h3 className="text-center font-semibold text-gray-800">Gastos Excessivos</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Solução Section */}
      <section id="solucao" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-blue-900 mb-6">
                CompraÁgil
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                Solução ideal para modernizar a gestão de compras da Prefeitura
              </p>
              
              <div className="space-y-4">
                {[
                  { icon: TrendingUp, title: 'Economia', desc: 'Reduza custos e otimize recursos' },
                  { icon: Zap, title: 'Velocidade', desc: 'Processos até 100% mais rápidos' },
                  { icon: Shield, title: 'Segurança', desc: 'Conformidade e Transparência' },
                  { icon: Brain, title: 'IA - DFD, ETP, AR e TR', desc: 'Inteligência Artificial aplicada na gestão pública' }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-4 bg-blue-50 p-4 rounded-xl hover:bg-blue-100 transition">
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <item.icon className="text-white" size={24} />
                    </div>
                    <div>
                      <h4 className="font-bold text-blue-900 text-lg">{item.title}</h4>
                      <p className="text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 lg:p-12">
                {/* Container com layout em cruz */}
                <div className="relative max-w-4xl mx-auto">
                  
                  {/* Linha superior - Administração e Saúde */}
                  <div className="grid grid-cols-2 gap-8 lg:gap-16 mb-8 lg:mb-12">
                    {/* Administração - Esquerda */}
                    <div className="flex justify-end">
                      <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group w-40">
                        <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:scale-110 transition-transform">
                          <Building2 className="text-white" size={32} />
                        </div>
                        <div className="font-semibold text-blue-900 text-sm">Administração</div>
                      </div>
                    </div>
                    
                    {/* Saúde - Direita */}
                    <div className="flex justify-start">
                      <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group w-40">
                        <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:scale-110 transition-transform">
                          <Heart className="text-white" size={32} />
                        </div>
                        <div className="font-semibold text-blue-900 text-sm">Saúde</div>
                      </div>
                    </div>
                  </div>

                  {/* Central de Compras - Centro */}
                  <div className="text-center mb-8 lg:mb-12">
                    <div className="inline-flex items-center justify-center mb-4">
                      <div className="w-24 h-24 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center shadow-2xl">
                        <Building2 className="text-white" size={48} />
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-blue-900 mb-3">Central de Compras Informatizada</h3>
                    <div className="w-20 h-1 bg-orange-500 mx-auto rounded-full"></div>
                  </div>

                  {/* Linha inferior - Educação e Social */}
                  <div className="grid grid-cols-2 gap-8 lg:gap-16 mb-8">
                    {/* Educação - Esquerda */}
                    <div className="flex justify-end">
                      <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group w-40">
                        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:scale-110 transition-transform">
                          <GraduationCap className="text-white" size={32} />
                        </div>
                        <div className="font-semibold text-blue-900 text-sm">Educação</div>
                      </div>
                    </div>
                    
                    {/* Social - Direita */}
                    <div className="flex justify-start">
                      <div className="bg-white rounded-2xl p-6 text-center shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 group w-40">
                        <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:scale-110 transition-transform">
                          <Users className="text-white" size={32} />
                        </div>
                        <div className="font-semibold text-blue-900 text-sm">Social</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Seção Demais Secretarias */}
                <div className="text-center mt-10 pt-8 border-t border-blue-200">
                  <p className="text-blue-700 font-medium flex items-center justify-center gap-2">
                    <span className="text-xl text-orange-500">+</span>
                    <span>Demais secretarias</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mapa Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">
              Solução Validada por Mais de 80 Cidades
            </h2>
            <p className="text-xl text-blue-200">Na Bahia e Alagoas</p>
          </div>
          
          <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-8 border border-white border-opacity-20">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-5xl font-bold text-orange-400 mb-2">80+</div>
                <div className="text-lg">Cidades Atendidas</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-orange-400 mb-2">100%</div>
                <div className="text-lg">Êxito na Implantação</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-orange-400 mb-2">92%</div>
                <div className="text-lg">Aprovação dos Clientes</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Impacto Section */}
      <section id="impacto" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Impacto do Compra Ágil nas Prefeituras
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { 
                icon: TrendingUp, 
                percent: '30%', 
                title: 'De Economia nas Compras Públicas',
                gradient: 'from-yellow-400 to-yellow-600'
              },
              { 
                icon: LineChart, 
                percent: '60%', 
                title: 'Aumento no Número de Licitações Realizadas',
                gradient: 'from-orange-400 to-orange-600'
              },
              { 
                icon: Zap, 
                percent: '100%', 
                title: 'Aumento da Velocidade do Processo de Compras',
                gradient: 'from-red-400 to-red-600'
              },
              { 
                icon: Award, 
                percent: '✓', 
                title: 'Mudança Cultural no Planejamento de Compras',
                gradient: 'from-pink-500 to-pink-700'
              }
            ].map((item, idx) => (
              <div key={idx} className="relative group">
                <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} rounded-2xl transform group-hover:scale-105 transition`}></div>
                <div className="relative bg-white rounded-2xl p-8 m-1 shadow-xl">
                  <div className={`w-20 h-20 bg-gradient-to-br ${item.gradient} rounded-full flex items-center justify-center mx-auto mb-6`}>
                    <item.icon className="text-white" size={40} />
                  </div>
                  <div className="text-5xl font-bold text-gray-900 mb-4 text-center">{item.percent}</div>
                  <p className="text-center text-gray-700 font-semibold">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processo Section */}
      <section id="processo" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              A Eficiência na Sua Gestão de Compras Começa Agora!
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-5 gap-6">
            {[
              { num: '1', title: 'Diagnóstico Estrutural', desc: 'Avaliação da estrutura mínima necessária' },
              { num: '2', title: 'Planejamento', desc: 'Organização e suporte no planejamento' },
              { num: '3', title: 'Central de Compras Informatizada', desc: 'Apoio na criação de uma central robusta' },
              { num: '4', title: 'Gestão no Sistema', desc: 'Treinamento e suporte completo' },
              { num: '5', title: 'Almoxarifado', desc: 'Criação e organização do almoxarifado' }
            ].map((step, idx) => (
              <div key={idx} className="relative">
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center mb-4 text-white font-bold text-xl">
                    {step.num}
                  </div>
                  <h3 className="font-bold text-blue-900 mb-2">{step.title}</h3>
                  <p className="text-gray-600 text-sm">{step.desc}</p>
                </div>
                {idx < 4 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <ChevronDown className="text-orange-500 rotate-[-90deg]" size={32} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Integrações Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Integração com Outras Soluções
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {['SIAFIC', 'Pregão Eletrônico', 'Portais de Transparência', 'PNCP'].map((item, idx) => (
              <div key={idx} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 text-center hover:shadow-xl transition">
                <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Lock className="text-white" size={32} />
                </div>
                <h3 className="font-bold text-blue-900 text-lg">{item}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Time Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">
              Especialistas Dedicados ao Seu Sucesso
            </h2>
            <p className="text-xl text-blue-200">
              Um time completo para proporcionar uma experiência eficaz e eficiente
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: Users, title: 'Consultores', desc: 'Especialistas em gestão pública' },
              { icon: Shield, title: 'Suporte Técnico', desc: 'Atendimento ágil e eficiente' },
              { icon: Brain, title: 'TI', desc: 'Tecnologia de ponta' },
              { icon: Award, title: 'Sucesso do Cliente', desc: 'Acompanhamento contínuo' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 transition">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <item.icon className="text-white" size={32} />
                </div>
                <h3 className="font-bold text-xl mb-2 text-center">{item.title}</h3>
                <p className="text-blue-200 text-center">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Depoimentos Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              O Que Dizem Nossos Clientes
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
            <p className="text-xl text-gray-600 mt-6">
              Gestores que transformaram suas prefeituras com o Grupo Êxito
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
            {/* Depoimento 1 - Humberto Miranda */}
            <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 relative">
              {/* Aspas decorativas */}
              <div className="absolute top-6 left-6 text-6xl text-orange-500 opacity-20 font-serif">"</div>
              
              <div className="relative z-10">
                <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                  "Sabemos que temos que fazer uma administração profissional e responsável, pautada principalmente no que a Lei de Responsabilidade Fiscal impõe para que os gestores possam cumprir. E nesse aspecto se faz necessário uma boa assessoria, e isso tivemos com o Grupo Êxito... Nos dando esse suporte e orientação na gestão pública como um todo, mas acima de tudo, como planejar melhor a gestão municipal, sendo este o maior desafio da gestão pública para minimizar os erros e criar condições administrativas para uma boa gestão..."
                </p>
                
                <div className="flex items-center gap-4 pt-6 border-t border-gray-200">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-xl">HM</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-blue-900 text-lg">Humberto Miranda</h4>
                    <p className="text-gray-600">Prefeito Municipal de Miguel Calmon - BA</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Depoimento 2 - Marcelo Lima */}
            <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 relative">
              {/* Aspas decorativas */}
              <div className="absolute top-6 left-6 text-6xl text-orange-500 opacity-20 font-serif">"</div>
              
              <div className="relative z-10">
                <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                  "Era um grande sonho implantar o sistema de compras em nosso município, um sistema de compras que fosse centralizado e todos os processos pudessem ser auditados, acompanhados e que todos tivessem o mesmo fluxo... A evolução do processo se deu a partir do momento que se criou uma mentalidade dentro da equipe, de que a legalidade e a economicidade desses processos justificava a contratação do Grupo Êxito... O Município de Quebrangulo hoje trabalha com muito mais tranquilidade e planejamento, e tem trazido muita economia para gestão municipal."
                </p>
                
                <div className="flex items-center gap-4 pt-6 border-t border-gray-200">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-xl">ML</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-blue-900 text-lg">Marcelo Lima</h4>
                    <p className="text-gray-600">Prefeito de Quebrangulo - AL</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Estatística adicional */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-2 bg-blue-900 text-white px-6 py-3 rounded-full shadow-lg">
              <Award className="text-orange-400" size={24} />
              <span className="font-semibold text-lg">98% de Satisfação dos Nossos Clientes</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final Section */}
      <section id="contato" className="py-20 bg-gradient-to-r from-orange-500 to-orange-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Agende agora uma demonstração gratuita e veja como transformar sua gestão
          </h2>
          <p className="text-xl mb-12 text-orange-100">
            A Êxito garante 100% de sucesso!
          </p>
          
          <div className="bg-white rounded-2xl p-8 text-gray-900 shadow-2xl">
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="text-left">
                <h3 className="font-bold text-lg mb-2 text-blue-900">Antônio Sampaio - Diretor</h3>
                <p className="text-gray-600">Tel: (71) 99957-3729</p>
              </div>
              <div className="text-left">
                <h3 className="font-bold text-lg mb-2 text-blue-900">Márcio Santos - Comercial</h3>
                <p className="text-gray-600">Tel: (71) 99740-5767</p>
              </div>
            </div>
            
            <a href="https://wa.me/+5571997405767" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-900 to-blue-700 text-white px-12 py-4 rounded-full font-bold text-lg hover:shadow-xl transition transform hover:scale-105 inline-block"
            >Quero Conhecer a Solução!</a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-blue-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center mb-4">
                {/* Esta é a imagem do logo no footer */}
                <img 
                  src="/exito-logo-web.png" 
                  alt="Logo Êxito Gestão Tecnológica" 
                  className="w-12 h-12" 
                />
                <div className="ml-3">
                  <div className="text-xl font-bold">ÊXITO</div>
                  <div className="text-xs">GESTÃO TECNOLÓGICA</div>
                </div>
              </div>
              <p className="text-blue-200">
                Nosso trabalho transforma municípios em referências.
              </p>
            </div>
            
            <div>
              <h3 className="font-bold text-lg mb-4">Links Rápidos</h3>
              <ul className="space-y-2">
                <li><button onClick={() => scrollToSection('solucao')} className="text-blue-200 hover:text-white transition">Solução</button></li>
                <li><button onClick={() => scrollToSection('impacto')} className="text-blue-200 hover:text-white transition">Impacto</button></li>
                <li><button onClick={() => scrollToSection('processo')} className="text-blue-200 hover:text-white transition">Processo</button></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-bold text-lg mb-4">Contato</h3>
              <p className="text-blue-200 mb-2">www.grupoexito.com.br</p>
              <p className="text-blue-200">Atendendo Bahia e Alagoas</p>
            </div>
          </div>
          
          <div className="border-t border-blue-700 mt-8 pt-8 text-center text-blue-200">
            <p>&copy; 2025 Grupo Êxito. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Import Alert Triangle
const AlertTriangle = ({ className, size }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);